import { render, staticRenderFns } from "./FieldDescriptor.vue?vue&type=template&id=28b5f7fa&scoped=true"
import script from "./FieldDescriptor.vue?vue&type=script&lang=js"
export * from "./FieldDescriptor.vue?vue&type=script&lang=js"
import style0 from "./FieldDescriptor.vue?vue&type=style&index=0&id=28b5f7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5f7fa",
  null
  
)

export default component.exports